import React, { useState, useEffect } from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import clsx from 'clsx';
import facebook from '../../asset/svg/facebook.svg';
import instagram from '../../asset/svg/instagram.svg';
import twitter from '../../asset/svg/twitter.svg';
import youtube from '../../asset/svg/youtube.svg';
import './FooterStyles.css';
import {
  Link,
  Grid,
  Hidden,
  IconButton,
  Toolbar,
  Menu,
  MenuItem,
  ListItemText,
  ListItem,
  List,
  Drawer,
  Select,
  Button,
} from '@material-ui/core';
import useStyles from './styles';

export default function Footer() {
  const classes = useStyles();
  const [isVisit, setIsVisit] = React.useState(false);
  const [isHover, setIsHover] = React.useState(false);
  const [activeCountry, setActiveCountry] = React.useState('');

  const visitCountry = isVisit => {
    setIsVisit(isVisit);
  };

  const toggleHover = (isHover, country) => {
    setIsHover(isHover);
    setActiveCountry(country);
  };

  const openChatHead = event => {
    window['chatNowButtonToggle'](event);
  };

  return (
    <div>
      <div className="nxtg-footer-wrapper">
        <div className="nxtg-footer-container">
          <div className="nxtg-footer-top">
            <div className="nxtg-footer-left-content">
              <div className="nxtg-footer-logo-content">
                <a
                  href="https://www.fwd.com.ph/"
                  type="svg+xml"
                  aria-label="FWD Logo"
                >
                  <svg
                    focusable="false"
                    viewBox="0 0 105 36"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <path
                      d="m85.0647368 16.8813014c.2339474.2394642.3647369.553646.3647369.8886508 0 .332555-.1307895.6510239-.3647369.8898756l-6.2158772 6.1452248c-.2468421.2388517-.5728947.3680766-.9001754.3680766-.1633333 0-.3291228-.0275598-.4881579-.0967656-.472807-.1947559-.7810526-.6516363-.7810526-1.1593492v-12.2922871c0-.5107751.3082456-.9664306.7810526-1.1648613.4771053-.1929186 1.0229825-.0839043 1.3883333.2737608z"
                      fill="#e87722"
                    ></path>
                    <path
                      d="m46.1005263.88926316c-.7386842.59467942-1.2642982 1.29898564-1.5903509 2.12026794-.3242105.81699522-.6821929 2.00390431-1.1009649 3.56991388l-.3278947 1.22855502-4.0403509 15.8530144-4.708421-20.27789478c-.4003509-1.93776077-1.4890351-3.13385646-4.1846492-3.13385646h-28.77491224c-1.32263158 0-1.36929825 1.39330143-1.37298246 1.4049378v32.86047844s.02210526.6987943.6981579.6987943h2.67350877c1.92008772 0 4.37438596-1.2346794 4.37438596-4.6398469v-10.0103349h10.07631577c3.8432456 0 4.7790351-2.7363828 4.7790351-4.2925933v-.5781436c0-.552421-.1872807-.8874258-.8553509-.8874258h-13.99999997v-8.29182776h19.79280697l5.9727193 22.93833496c.1829825.6865454 1.2280702 4.3164784 1.2280702 4.3164784.402193 1.2726508.3579825 1.4576077 1.4448246 1.4576077h2.4199123c2.9731579 0 3.9998245-1.8269091 4.5248245-3.1160957.2640351-.6987943.4513158-1.0062392.8756141-2.5820479l5.2659649-19.77385641 5.5699123 19.67525361c.1811403.6871579 1.1531578 4.331177 1.1531578 4.331177.400965 1.2683636.3604386 1.4631196 1.4478948 1.4631196h2.4174561c2.975 0 4.0035088-1.8287464 4.5291228-3.1258947.2572807-.6987943.5170176-1.3669665.943772-2.9391005l5.4753508-22.62537798h16.9547369c1.4577193 0 2.6311403.12677512 3.6878947.44585646 1.3668421.40972249 2.5826316 1.43188517 3.5970176 3.03157892.9824561 1.5684594 1.5442982 4.3146412 1.5700877 7.725933-.0018421 3.8448996-1.155 7.2580288-3.2967544 9.1026986-.4771053.429933-1.0371053.7631005-1.7008772 1.0062392-.6766667.2486508-1.330614.4054354-1.9507895.4679043-.6680701.0698182-1.5522807.2045551-2.7152631.2143541h-.016579l-3.6977193.0061244h-5.3120175l-.0264035-.0061244c-1.1488597 0-1.1850877.6651101-1.1850877.9517321v1.3755406c0 2.0014546 1.6566666 4.3023924 4.9835087 4.3023924h.1148246l6.4535088-.0036747c1.6425438-.0165358 3.116228-.1365741 4.4370175-.3613397 1.3281579-.2308899 2.5783333-.6106028 3.7419298-1.1624115 1.1635965-.5444593 2.2381579-1.2671387 3.2163158-2.1588516 1.236053-1.1562871 2.244912-2.4632345 3.031491-3.9245168.777369-1.4618947 1.350877-3.0903732 1.711316-4.8829856.340175-1.6927847.509035-2.8974546.509035-4.9050335v-.0422584c-.056491-6.5010526-1.982719-11.1225263-5.8210525-14.34886123-1.4718421-1.26713875-3.1303509-2.13435406-4.9540351-2.58817225-1.6947368-.42564593-3.6958772-.63448803-5.9825439-.63448803h-20.5419298c-1.1273684.0122488-2.8165789.59222966-3.4662281 3.23858373l-4.4566666 20.14744498-4.7366667-15.79850718v.01163636l-.3180702-1.1642488c-.4568421-1.68421053-.8252631-2.89316747-1.0991228-3.62380862-.2757017-.72880382-.7607894-1.40371292-1.4736842-2.02778947-.7024561-.61856459-1.6965789-.92784689-2.9731579-.92784689-1.2661403 0-2.258421.29519617-2.9909649.88926316"
                      fill="#183028"
                    ></path>
                  </svg>
                </a>
              </div>
              <div>
                <div className="nxtg-country-wrapper">
                  <span className="nxtg-country-label">Visit FWD</span>
                  <div className="nxtg-dropdown-wrapper nxtg-dropmenu-country">
                    <div
                      className="nxtg-country-dropmenu-container"
                      onClick={() => visitCountry(!isVisit)}
                    >
                      <span>Philippines</span>
                      <svg
                        focusable="false"
                        viewBox="0 0 48 48"
                        aria-hidden="true"
                        role="presentation"
                      >
                        <g
                          stroke="none"
                          stroke-width="1"
                          fill="none"
                          fill-rule="evenodd"
                        >
                          <path
                            d="M12.5855,21.2426 L23.1715,10.6576 L33.7575,21.2426 L34.4645,20.5356 C35.6365,19.3646 35.6365,17.4646 34.4645,16.2936 L23.1715,4.9996 L11.8785,16.2936 C10.7065,17.4646 10.7065,19.3646 11.8785,20.5356 L12.5855,21.2426 Z M34.4645,27.1216 C35.6365,28.2926 35.6365,30.1926 34.4645,31.3636 L23.1715,42.6576 L11.8785,31.3636 C10.7065,30.1926 10.7065,28.2926 11.8785,27.1216 L12.5855,26.4146 L23.1715,36.9996 L33.7575,26.4146 L34.4645,27.1216 Z"
                            fill="#E87722"
                          ></path>
                        </g>
                      </svg>
                    </div>
                    {isVisit && (
                      <div className={classes.whiteBG}>
                        <Select
                          open={isVisit}
                          onClose={() => {
                            visitCountry(!isVisit);
                          }}
                        >
                          <Link
                            href="https://www.fwd.com.ph/"
                            onMouseEnter={() => {
                              toggleHover(true, 'FWD');
                            }}
                            onMouseLeave={() => {
                              toggleHover(false, 'FWD');
                            }}
                            className={
                              isHover && activeCountry === 'FWD'
                                ? classes.listItemHovered
                                : classes.listItem
                            }
                          >
                            FWD Group
                          </Link>
                          <Link
                            href="https://www.fwd.com.hk/"
                            onMouseEnter={() => {
                              toggleHover(true, 'HK');
                            }}
                            onMouseLeave={() => {
                              toggleHover(false, 'HK');
                            }}
                            className={
                              isHover && activeCountry === 'HK'
                                ? classes.listItemHovered
                                : classes.listItem
                            }
                          >
                            Hong Kong
                          </Link>
                          <Link
                            href="https://www.fwd.co.id/"
                            onMouseEnter={() => {
                              toggleHover(true, 'ID');
                            }}
                            onMouseLeave={() => {
                              toggleHover(false, 'ID');
                            }}
                            className={
                              isHover && activeCountry === 'ID'
                                ? classes.listItemHovered
                                : classes.listItem
                            }
                          >
                            Indonesia
                          </Link>
                          <Link
                            href="https://www.fwdfujilife.co.jp/"
                            onMouseEnter={() => {
                              toggleHover(true, 'JP');
                            }}
                            onMouseLeave={() => {
                              toggleHover(false, 'JP');
                            }}
                            className={
                              isHover && activeCountry === 'JP'
                                ? classes.listItemHovered
                                : classes.listItem
                            }
                          >
                            Japan
                          </Link>
                          <Link
                            href="https://www.fwd.com.ph/"
                            onMouseEnter={() => {
                              toggleHover(true, 'PH');
                            }}
                            onMouseLeave={() => {
                              toggleHover(false, 'PH');
                            }}
                            className={
                              isHover && activeCountry === 'PH'
                                ? classes.listItemHovered
                                : classes.listItem
                            }
                          >
                            <span>Philippines</span>
                            <span>
                              <svg
                                focusable="false"
                                viewBox="0 0 48 48"
                                aria-hidden="true"
                                role="presentation"
                              >
                                <g
                                  stroke="none"
                                  stroke-width="1"
                                  fill="none"
                                  fill-rule="evenodd"
                                >
                                  <path
                                    d="M12.5855,21.2426 L23.1715,10.6576 L33.7575,21.2426 L34.4645,20.5356 C35.6365,19.3646 35.6365,17.4646 34.4645,16.2936 L23.1715,4.9996 L11.8785,16.2936 C10.7065,17.4646 10.7065,19.3646 11.8785,20.5356 L12.5855,21.2426 Z M34.4645,27.1216 C35.6365,28.2926 35.6365,30.1926 34.4645,31.3636 L23.1715,42.6576 L11.8785,31.3636 C10.7065,30.1926 10.7065,28.2926 11.8785,27.1216 L12.5855,26.4146 L23.1715,36.9996 L33.7575,26.4146 L34.4645,27.1216 Z"
                                    fill="#E87722"
                                  ></path>
                                </g>
                              </svg>
                            </span>
                            <svg
                              focusable="false"
                              viewBox="0 0 48 48"
                              aria-hidden="true"
                              role="presentation"
                              height="1.5rem"
                              className={classes.marginLeft}
                            >
                              <g
                                stroke="none"
                                stroke-width="1"
                                fill="none"
                                fill-rule="evenodd"
                              >
                                <path
                                  d="M15.3701,37.044 L6.0001,27.673 L6.7071,26.966 C7.8791,25.795 9.7781,25.795 10.9491,26.966 L15.3701,31.387 L35.8791,10.878 C37.0501,9.707 38.9501,9.707 40.1211,10.878 L40.8281,11.586 L15.3701,37.044 Z"
                                  fill="#E87722"
                                ></path>
                              </g>
                            </svg>
                          </Link>
                          <Link
                            href="https://www.fwd.co.th/"
                            onMouseEnter={() => {
                              toggleHover(true, 'TH');
                            }}
                            onMouseLeave={() => {
                              toggleHover(false, 'TH');
                            }}
                            className={
                              isHover && activeCountry === 'TH'
                                ? classes.listItemHovered
                                : classes.listItem
                            }
                          >
                            Thailand
                          </Link>
                          <Link
                            href="https://www.fwd.com.vn/"
                            onMouseEnter={() => {
                              toggleHover(true, 'VT');
                            }}
                            onMouseLeave={() => {
                              toggleHover(false, 'VT');
                            }}
                            className={
                              isHover && activeCountry === 'VT'
                                ? classes.listItemHovered
                                : classes.listItem
                            }
                          >
                            Vietnam
                          </Link>
                        </Select>
                      </div>
                    )}
                  </div>
                </div>
                <div className="nxtg-footer-contact-wrapper">
                  <a href="tel:63288888388">
                    <div className="nxtg-footer-call-icon">
                      <svg
                        focusable="false"
                        viewBox="0 0 48 48"
                        aria-hidden="true"
                        role="presentation"
                      >
                        <path
                          d="M10.5232,18.3972 C10.5472,18.4902 11.2982,21.2522 13.8022,24.3312 C15.0602,25.8942 19.5052,31.2222 24.1002,34.4972 C27.1852,36.7052 29.6592,37.4822 29.6842,37.4882 L29.8802,37.5602 C31.5142,38.2502 32.5532,37.9272 32.5972,37.9132 L32.7192,37.8722 C33.5822,37.6222 34.5062,36.9192 35.3052,36.2802 C36.2642,35.4922 37.0692,34.7382 37.7412,33.9982 C36.9552,33.1152 35.2532,31.5062 34.3992,30.8152 C34.2322,30.6812 34.0602,30.5382 33.8892,30.3962 C33.6082,30.1602 33.3382,29.9362 33.0792,29.7502 L33.0542,29.7752 C32.8622,29.9682 32.6312,30.2452 32.3792,30.5422 C31.2432,31.8842 30.4182,32.7862 29.3402,33.0942 C27.2532,33.7982 24.0042,31.1352 23.6412,30.8292 C21.5052,29.0652 18.4832,26.2622 17.0462,24.2012 C15.3162,21.7292 14.4262,20.0332 14.9172,18.5632 C15.2082,17.5882 16.1042,16.7622 17.4352,15.6202 C17.7362,15.3622 18.0162,15.1262 18.2092,14.9332 C18.2182,14.9232 18.2282,14.9142 18.2372,14.9052 C17.9592,14.5072 17.6072,14.0962 17.2652,13.6962 L17.1712,13.5862 C16.4842,12.7382 14.8922,11.0542 13.9762,10.2462 C13.2002,10.9282 12.4472,11.7362 11.7162,12.6672 C11.0792,13.4632 10.3932,14.3642 10.1292,15.2152 L10.1052,15.2992 C10.0242,15.5792 9.8082,16.6092 10.4312,18.1202 L10.5232,18.3972 Z M31.8562,41.9962 C30.9292,41.9962 29.7522,41.8322 28.4132,41.2812 C27.8202,41.0882 25.0812,40.1182 21.7752,37.7522 C16.7682,34.1832 12.0262,28.5032 10.6922,26.8482 C7.9032,23.4172 6.8962,20.2702 6.6852,19.5242 C5.7802,17.2552 5.9512,15.4542 6.1922,14.4502 L6.1922,14.4232 L6.2722,14.1492 C6.7282,12.5812 7.7042,11.2782 8.5822,10.1822 C9.6012,8.8842 10.6882,7.7562 11.8002,6.8432 C12.9802,5.8982 14.0832,5.9172 14.8032,6.0972 L15.1242,6.2072 C16.8502,6.9682 20.2482,11.0292 20.2802,11.0702 C20.7612,11.6302 21.2812,12.2362 21.7212,12.9202 C22.1392,13.4572 22.3892,14.0402 22.4662,14.6552 C22.7382,16.1872 21.6482,17.1942 21.1832,17.6242 L21.0362,17.7622 C20.7872,18.0112 20.4292,18.3222 20.0402,18.6562 C19.7352,18.9182 19.2412,19.3412 18.9202,19.6622 C19.0992,20.0362 19.4802,20.7022 20.2942,21.8652 C21.3052,23.3142 23.6662,25.6622 26.2022,27.7572 C26.7522,28.2192 27.7322,28.8222 28.3202,29.0862 C28.6372,28.7722 29.0662,28.2662 29.3272,27.9562 C29.6612,27.5642 29.9722,27.2012 30.2252,26.9482 L30.3572,26.8102 C30.8012,26.3392 31.8452,25.2362 33.4512,25.5382 L33.6322,25.5812 C34.1372,25.7262 34.5552,25.9652 34.8912,26.1562 C35.5262,26.5522 35.9972,26.9442 36.4532,27.3242 C36.6032,27.4502 36.7542,27.5752 36.9072,27.6982 C36.9552,27.7372 41.0212,31.1392 41.7792,32.8632 L41.8972,33.2182 C42.2602,34.7912 41.4302,35.8272 41.1572,36.1672 C40.2302,37.2582 39.1522,38.2962 37.8242,39.3872 C36.7172,40.2732 35.4312,41.2352 33.8892,41.6972 C33.5972,41.7962 32.8792,41.9962 31.8562,41.9962 L31.8562,41.9962 Z"
                          fill=""
                        ></path>
                      </svg>
                    </div>
                    <div className="nxtg-footer-call-text nxtg-footer-call-small-text">
                      +632 8888 8388
                    </div>
                  </a>
                  <div className="nxtg-full-line nxtg-full-social-line">
                    <hr />
                  </div>
                  <div className="nxtg-footer-social-wrapper nxtg-footer-social-wrapper-desktop">
                    <ul>
                      <li>
                        <a
                          href="https://www.facebook.com/fwdlife.ph/?fref=ts"
                          aria-label="Facebook icon"
                        >
                          <img src={facebook} alt={facebook} />
                          {/* <img
                          icon="facebook"
                          alt="facebook"
                          src="assets/svg/facebook.svg"
                          loading="lazy"
                        /> */}
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.instagram.com/fwdlife_ph/"
                          aria-label="Instagram icon"
                        >
                          <img src={instagram} alt={instagram} />
                          {/* <img
                          icon="instagram"
                          alt="instagram"
                          src="assets/svg/instagram.svg"
                          loading="lazy"
                        /> */}
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://twitter.com/fwdlife_ph?lang=en"
                          aria-label="Twitter icon"
                        >
                          <img src={twitter} alt={twitter} />
                          {/* <img
                          icon="Twitter"
                          alt="instagram"
                          src="assets/svg/twitter.svg"
                          loading="lazy"
                        /> */}
                        </a>
                      </li>
                      <li>
                        <a
                          href="https://www.youtube.com/channel/UCFBbfoRHRezq6_niSnH9Uhg"
                          aria-label="Youtube icon"
                        >
                          <img src={youtube} alt={youtube} />
                          {/* <img
                          icon="Youtube"
                          alt="instagram"
                          src="assets/svg/youtube.svg"
                          loading="lazy"
                        /> */}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="nxtg-footer-right-content">
              <div className="nxtg-footer-links-wrapper nxtg-accordion-wrapper">
                <div className="nxtg-footer-links-column">
                  <ul>
                    <li>
                      <div className="nxtg-accordion-trigger">
                        <div className="nxtg-footer-primary-link">
                          <a
                            href="https://www.fwd.com.ph/products/"
                            className="nxtg-link-highlight"
                          >
                            Products
                          </a>
                        </div>
                      </div>
                      <ul className="nxtg-accordion-collapse">
                        <li>
                          <a href="https://www.fwd.com.ph/products/life-protection/">
                            Life protection
                          </a>
                        </li>
                        <li>
                          <a href="https://www.fwd.com.ph/products/health-protection/">
                            Health protection
                          </a>
                        </li>
                        <li>
                          <a href="https://www.fwd.com.ph/products/investment/">
                            Investments
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <div className="nxtg-footer-links-column">
                  <ul>
                    <li>
                      <div className="nxtg-accordion-trigger">
                        <div className="nxtg-footer-primary-link">
                          <a
                            href="https://www.fwd.com.ph/claims/"
                            className="nxtg-link-highlight"
                          >
                            Claims
                          </a>
                        </div>
                      </div>
                      <ul className="nxtg-accordion-collapse">
                        <li>
                          <a href="https://www.fwd.com.ph/support/forms/">
                            Find a form
                          </a>
                        </li>
                        <li>
                          <a href="https://www.fwd.com.ph/claims/death/">
                            Loss of life claims
                          </a>
                        </li>
                        <li>
                          <a href="https://www.fwd.com.ph/claims/critical-illness/">
                            Critical illness claims
                          </a>
                        </li>
                        <li>
                          <a href="https://www.fwd.com.ph/claims/disability/">
                            Disability claims
                          </a>
                        </li>
                        <li>
                          <a href="https://www.fwd.com.ph/claims/hospitalization/">
                            Hospitalization claims
                          </a>
                        </li>
                        <li>
                          <a href="https://www.fwd.com.ph/claims/waiver-of-premium/">
                            Waiver of premium claims
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <div className="nxtg-footer-links-column">
                  <ul>
                    <li>
                      <div className="nxtg-accordion-trigger">
                        <div className="nxtg-footer-primary-link">
                          <a
                            href="https://www.fwd.com.ph/support/"
                            className="nxtg-link-highlight"
                          >
                            Support
                          </a>
                        </div>
                      </div>
                      <ul className="nxtg-accordion-collapse">
                        <li>
                          <a href="https://www.fwd.com.ph/support/faq/">FAQs</a>
                        </li>
                        <li>
                          <a href="tel:63288888388">Call 8888 8388</a>
                        </li>
                        <li>
                          {/* <a href="#" onClick={chatNowButtonToggle(event)}> */}
                          <a href="#" onClick={openChatHead}>
                            Live chat
                          </a>
                        </li>
                        <li>
                          <a>Email us</a>
                        </li>
                        <li>
                          <a>Online inquiry</a>
                        </li>
                        <li>
                          <a href="https://www.fwd.com.ph/branch-locator/">
                            Locate us
                          </a>
                        </li>
                        <li>
                          <a href="https://investment.fwd.com.ph/">
                            Fund information
                          </a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
                <div className="nxtg-footer-links-column">
                  <ul>
                    <li>
                      <a
                        href="https://www.fwd.com.ph/blog/"
                        className="nxtg-link-highlight"
                      >
                        Blog
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.fwd.com.ph/about/"
                        className="nxtg-link-highlight"
                      >
                        About us
                      </a>
                    </li>
                    <li>
                      <a
                        href="https://www.fwd.com.ph/news-press/press/"
                        className="nxtg-link-highlight"
                      >
                        Press release
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="nxtg-footer-social-wrapper nxtg-footer-social-wrapper-mobile">
            <ul>
              <li>
                <a
                  href="https://www.facebook.com/fwdlife.ph/?fref=ts"
                  aria-label="Facebook icon"
                >
                  <img src={facebook} alt={facebook} />
                  {/* <img
                          icon="facebook"
                          alt="facebook"
                          src="assets/svg/facebook.svg"
                          loading="lazy"
                        /> */}
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/fwdlife_ph/"
                  aria-label="Instagram icon"
                >
                  <img src={instagram} alt={instagram} />
                  {/* <img
                          icon="instagram"
                          alt="instagram"
                          src="assets/svg/instagram.svg"
                          loading="lazy"
                        /> */}
                </a>
              </li>
              <li>
                <a
                  href="https://twitter.com/fwdlife_ph?lang=en"
                  aria-label="Twitter icon"
                >
                  <img src={twitter} alt={twitter} />
                  {/* <img
                          icon="Twitter"
                          alt="instagram"
                          src="assets/svg/twitter.svg"
                          loading="lazy"
                        /> */}
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UCFBbfoRHRezq6_niSnH9Uhg"
                  aria-label="Youtube icon"
                >
                  <img src={youtube} alt={youtube} />
                  {/* <img
                          icon="Youtube"
                          alt="instagram"
                          src="assets/svg/youtube.svg"
                          loading="lazy"
                        /> */}
                </a>
              </li>
            </ul>
          </div>
          <div className="nxtg-country-wrapper nxtg-footer-country-wrapper-mobile">
            <span className="nxtg-country-label">Visit FWD</span>
            <div className="nxtg-dropdown-wrapper nxtg-dropmenu-country nxtg-dropmenu-country-mobile">
              <div className="nxtg-country-dropmenu-container">
                <span>Philippines</span>
                <svg
                  focusable="false"
                  viewBox="0 0 48 48"
                  aria-hidden="true"
                  role="presentation"
                >
                  <g
                    stroke="none"
                    stroke-width="1"
                    fill="none"
                    fill-rule="evenodd"
                  >
                    <path
                      d="M12.5855,21.2426 L23.1715,10.6576 L33.7575,21.2426 L34.4645,20.5356 C35.6365,19.3646 35.6365,17.4646 34.4645,16.2936 L23.1715,4.9996 L11.8785,16.2936 C10.7065,17.4646 10.7065,19.3646 11.8785,20.5356 L12.5855,21.2426 Z M34.4645,27.1216 C35.6365,28.2926 35.6365,30.1926 34.4645,31.3636 L23.1715,42.6576 L11.8785,31.3636 C10.7065,30.1926 10.7065,28.2926 11.8785,27.1216 L12.5855,26.4146 L23.1715,36.9996 L33.7575,26.4146 L34.4645,27.1216 Z"
                      fill="#E87722"
                    ></path>
                  </g>
                </svg>
              </div>
              <div className="nxtg-dropdown-content">
                <ul>
                  <li>
                    <a href="https://www.fwd.com/">
                      <span>FWD Group</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.fwd.com.hk/">
                      <span>Hong Kong</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.fwd.co.id/">
                      <span>Indonesia</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.fwdfujilife.co.jp/">
                      <span>Japan</span>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.fwd.com.ph/"
                      className="nxtg-dropdown-active"
                    >
                      <span>Philippines</span>
                      <span>
                        <svg
                          focusable="false"
                          viewBox="0 0 48 48"
                          aria-hidden="true"
                          role="presentation"
                        >
                          <g
                            stroke="none"
                            stroke-width="1"
                            fill="none"
                            fill-rule="evenodd"
                          >
                            <path d="M15.3701,37.044 L6.0001,27.673 L6.7071,26.966 C7.8791,25.795 9.7781,25.795 10.9491,26.966 L15.3701,31.387 L35.8791,10.878 C37.0501,9.707 38.9501,9.707 40.1211,10.878 L40.8281,11.586 L15.3701,37.044 Z"></path>
                          </g>
                        </svg>
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.fwd.co.th/">
                      <span>Thailand</span>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.fwd.com.vn/">
                      <span>Vietnam</span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div className="nxtg-footer-bottom">
            <div className="nxtg-full-line nxtg-footer-bottom-full-line">
              <hr />
            </div>
            <div className="nxtg-footer-bottom-wrapper">
              <div className="nxtg-footer-quick-links">
                <ul>
                  <li>
                    <a href="https://www.fwd.com.ph/sitemap/">Sitemap</a>
                  </li>
                  <li>
                    <a href="https://www.fwd.com.ph/online-security/">
                      Online security
                    </a>
                  </li>
                  <li>
                    <a href="https://www.fwd.com.ph/disclaimer/">Disclaimer</a>
                  </li>
                  <li>
                    <a href="https://www.fwd.com.ph/privacypolicy/">
                      Privacy policy
                    </a>
                  </li>
                  <li>
                    <a href="https://www.fwd.com.ph/terms-and-conditions/">
                      Terms and conditions
                    </a>
                  </li>
                </ul>
              </div>
              <div className="nxtg-full-line nxtg-footer-copyright-full-line">
                <hr />
              </div>
              <div className="nxtg-copyright-text">
                <p>
                  © Copyright 2021 FWD Life Insurance Public Company Limited.
                  All rights reserved.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    //       {/* <Grid container>
    //         <Grid item sm={12} md={3} className={classes.footer_menu}>
    //           <Link
    //             href="https://www.fwd.com.ph/en/contact-us/"
    //             variant="h5"
    //             className={clsx(classes.contactUs, classes.customLine)}
    //             target="_blank"
    //           >
    //             Contact Us
    //           </Link>
    //           <Typography variant="caption" className={classes.customLine}>
    //             FWD Customer Contact Hotline
    //           </Typography>
    //           <Typography
    //             variant="h5"
    //             className={clsx(classes.contactUsPhone, classes.customLine)}
    //           >
    //             +632 8888 8388
    //           </Typography>
    //           <Typography variant="caption" className={classes.customLine}>
    //             We're here for you, 24/7.
    //           </Typography>
    //         </Grid>
    //         <Hidden smDown>
    //           <Grid item md={5} className={classes.footerMenuBlock}>
    //             <Grid container spacing={2}>
    //               <Grid item md={3} className={classes.footer_menu}>
    //                 {options1.map(el => (
    //                   <Link
    //                     href={el.path}
    //                     target="_blank"
    //                     variant="subtitle2"
    //                     key={el.label}
    //                     className={classes.menu_optional}
    //                   >
    //                     {el.label}
    //                   </Link>
    //                 ))}
    //               </Grid>
    //               <Grid item xs={4} className={classes.footer_menu}>
    //                 {options2.map(el => (
    //                   <Link
    //                     variant="subtitle2"
    //                     href={el.path}
    //                     target="_blank"
    //                     key={el.label}
    //                     className={classes.menu_optional}
    //                   >
    //                     {el.label}
    //                   </Link>
    //                 ))}
    //               </Grid>
    //               <Grid item xs={5} className={classes.footer_menu}>
    //                 {options3.map(el => (
    //                   <Link
    //                     variant="subtitle2"
    //                     href={el.path}
    //                     target="_blank"
    //                     key={el.label}
    //                     className={classes.menu_optional}
    //                   >
    //                     {el.label}
    //                   </Link>
    //                 ))}
    //               </Grid>
    //             </Grid>
    //           </Grid>
    //         </Hidden>
    //         <Hidden mdUp>
    //           <Grid item xs={12} className={classes.footerMenuBlock}>
    //             <Grid container>
    //               <Grid item xs={6} className={classes.footer_menu}>
    //                 {optionsMobile1.map(el => (
    //                   <Link
    //                     variant="subtitle2"
    //                     href={el.path}
    //                     target="_blank"
    //                     key={el.label}
    //                     className={classes.menu_optional}
    //                   >
    //                     {el.label}
    //                   </Link>
    //                 ))}
    //               </Grid>
    //               <Grid item xs={6} className={classes.footer_menu}>
    //                 {optionsMobile2.map(el => (
    //                   <Link
    //                     variant="subtitle2"
    //                     href={el.path}
    //                     target="_blank"
    //                     key={el.label}
    //                     className={classes.menu_optional}
    //                   >
    //                     {el.label}
    //                   </Link>
    //                 ))}
    //               </Grid>
    //             </Grid>
    //           </Grid>
    //         </Hidden>
    //   );
    // }
  );
}
